import { Fragment, HTMLAttributes } from 'react'
import Link from 'next/link'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Typography from '@/components/base/typography'

import { cn } from '@/lib/utils'
import { WPLink } from '@/types'

export type BreadcrumbsProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    items: WPLink[]
  }>

const Breadcrumbs = ({ items, ...props }: BreadcrumbsProps) => {
  return (
    <Container {...props}>
      <Grid>
        <ul className="col-span-2 flex items-center py-spacing-2xs md:col-span-6 lg:col-span-12">
          {items?.map((item, index) => {
            const label = (
              <Typography
                variant="small"
                className={cn([
                  {
                    'underline-active': index === items.length - 1,
                    'underline-effect': index < items.length - 1
                  }
                ])}
              >
                {item?.title}
              </Typography>
            )

            return (
              <Fragment key={index}>
                {item?.url ? (
                  <Link
                    href={item.url}
                    target="_self"
                    scroll={false}
                    className={cn([
                      {
                        'pointer-events-none': index === items.length - 1
                      }
                    ])}
                  >
                    {label}
                  </Link>
                ) : (
                  <span className="pointer-events-none">{label}</span>
                )}
                {index < items.length - 1 && (
                  <span className="mx-spacing-2xs text-[0.75em]">/</span>
                )}
              </Fragment>
            )
          })}
        </ul>
      </Grid>
    </Container>
  )
}

export default Breadcrumbs
